import axiosInstance from "../axios/axios";

export const validateTokenAPI = async (token) => {
 try {
   const response = await axiosInstance.get(`/validate-token/${token}`);
   return [response, null];
 } catch (error) {
   return [null, error];
 }
};

export const submitEnrollmentForm = async (data) => {
  try {
    const response = await axiosInstance.post("/client", data);
    return [response, null];
  } catch (error) {
    return [null, error];
  } 
}

export const verifyEnrollmentForm = async (data) => {
  try {
    const response = await axiosInstance.post("/verify-client", data);
    return [response, null];
  } catch (error) {
    return [null, error];
  } 
}

export const enrollmentInfo = async () => {
 try {
   const response = await axiosInstance.get("/enrollment-info");
   return [response, null];
 } catch (error) {
   return [null, error];
 } 
}

export const sahayatri = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=sahayatri&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const roaming = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=roaming&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const mobileinsure = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=mobileinsurance&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const datasangaibeemabiz200 = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=datasangaibeemabiz200&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const ncellsadhaion = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=ncellsadhaion&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const datasangaiphonebeema = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=datasangaiphonebeema&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const ncellsmartphoneoffer = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=ncellsmartphoneoffer&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const roamingsadhainon = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=roamingsadhainon&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const datasangaibeemaplus = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=datasangaibeemaplus&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
}

export const getMsisdnDetails = async (msisdn) => {
  try {
    const response = await axiosInstance.post('/api/getmsisdndetails', { msisdn });
    return [response, null];
  } catch (error) {
    return [null, error];
  }
};

export const datasangaibeemaretailer499 = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=datasangaibeemaretailer499&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
};

export const datasangaibeemaretailer999 = async (lang) => {
  try {
    const response = await axiosInstance.get(`/micro-claim/get-data?product_name=datasangaibeemaretailer999&lang=${lang}`);
    return [response, null];
  } catch (error) {
    return [null, error];
  }
};
